import { useApiMutation } from '../useApiMutation';
import { reviewsV2Endpoints } from '@/lib/api/endpoints';
import { apiPost, operationsClient } from '@/lib/api';

export interface JobStoriesShareResponse {
  shortUrl: string;
  expiresAt: string | null;
}

export type JobStoriesShareInput = {
  expiresInDays?: number;
  neverExpire?: boolean;
  headline?: string;
  accentColor?: string;
  description?: string;
  font?: string;
  showMap?: boolean;
  showFilters?: boolean;
  showAreas?: boolean;
  showPhotos?: boolean;
  showNotes?: boolean;
  showTechnician?: boolean;
  showJobDescription?: boolean;
  showPlatform?: boolean;
};

export function useCreateJobStoriesShare() {
  return useApiMutation<JobStoriesShareResponse, JobStoriesShareInput>({
    mutationFn: (input) =>
      apiPost<{ data: JobStoriesShareResponse }, JobStoriesShareInput>(
        operationsClient,
        reviewsV2Endpoints.createJobStoriesShare(),
        input,
      ).then((response) => response.data),
  });
}
